module.exports = __webpack_public_path__ + "static/media/women.cdc2047f.jpg";